module.exports = __webpack_public_path__ + "img/swap2.8bf5c1b6.svg";